module.exports = __webpack_public_path__ + "static/img/banner.70c4f06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jobs/banner.png
// module id = rOok
// module chunks = 1